import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';
import LeftNavBar from './LeftNavBar';
import HealthFacilityOverView from './HealthFacilityOverview';
import BadgesComponent from './../../components/common/Badges';
import BreadcrumbComponent from './../../components/common/Breadcrumb';
import NationalEmblem from './../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../assets/svg_main/BackArrowIconSvg.svg';
import './AppWrapperViewComponent.css';
import endpoints from './../../config/endpoints';
import axios from '../../utils/axiosExt';
import { ChildComponentHandlerUpgrade } from './HealthFacilityOverview/HealthFacilityUpgradeUi';
import { ChildComponentHandlerUpdate } from './HealthFacilityOverview/HealthFacilityUpdateUi';
import Auth from '../../utils/auth';
import { useDispatch } from 'react-redux';
import { setCreateMapPincodeWithHfr, setGeometryMapPoint, setMapLatLong, setMapManualAddress, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setMapServicesDown } from '@store/actions/facilityGeoMapAction';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import { errorLogger } from '@utils/applicationLogUtils';
import { dateFormate } from '@constants/index';
import { setStatusMessage } from '@constants/approvalConstants';
import dayjs from 'dayjs';

interface HealthFComponentProps {
    page: string;
    flow: string;
  }
interface facilityTypeProps {
  [key: string]: any
}

const TABS = ['Overview'];
const HealthFacilityView = (props: HealthFComponentProps) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { page, flow } = props;
    const [facility, setFacility] = useState<facilityTypeProps | null>(null);
    const [currentTab, setCurrentTab] = useState('Overview');
    const childRef1 = useRef<ChildComponentHandlerUpgrade>();
    const childRef2 = useRef<ChildComponentHandlerUpdate>();
    const [disableEditBtn, setDisableEditBtn] = useState(false);
    const [approvalReqId, setApprovalReqId] = useState('');
    const [approvalReqStatus, setApprovalReqStatus] = useState('');
    const [reqefectiveData, setReqefectiveData] = useState('');
    const [linkedFacilitiesRural, setLinkedFacilitiesRural] = useState<any>([]);
    const [linkedFacilitiesUrban, setLinkedFacilitiesUrban] = useState<any>([]);
    const [linkedVillageRural, setLinkedVillageRural] = useState<any>([]);
    const [linkedWardRural, setLinkedWardRural] = useState<any>([]);
    const [showLoader, setShowLoader] = useState<boolean>(true);

    const updateHandlerUpgrade = () => {
      
      if(childRef1.current) {
        childRef1.current.handleUpgradeSave();
      }
    }

    const clearMapStore = () => {
      dispatch(setGeometryMapPoint({mapPointer: '', distFenceGeometry: ''}));
      dispatch(setMapManualAddress(false));
      dispatch(setMapLatLong(null));
      dispatch(setMapManualLatLong(false));
      dispatch(setMapManualLatLongClicked(false));
      dispatch(setMapPincodeFirstTimeEdit(null));
      dispatch(setCreateMapPincodeWithHfr(null))
      dispatch(setMapServicesDown(false));
    }

    const updateHandlerUpdate = () => {
      
      if(childRef2.current) {
        childRef2.current.handleUpdateSave();
      }
    };

    const getFacility = () => {
      //axios.get(`${endpoints.getFacilityByFacilityId}/${id}`, Auth.loggedIn())
      axios.get(`${endpoints.getALLFacilityDetailsByFacilityId(id)}`, Auth.loggedIn())
        .then(async (result: any) => {
          if (result) {
            const allFacilityData=result.data.data
            const facilityDetails = allFacilityData?.facilityData[0];
            try{
              if(facilityDetails?.state_code){
                facilityDetails.isUsingGramPanchayat=await isUsingGramPanchayatUtils(facilityDetails?.state_code);
              }
              else{
                facilityDetails.isUsingGramPanchayat=false;
              }
            }
            catch(error:any){
               errorLogger(error?.response?.data||error?.response||error)
            }
            const facility_categoryResponse = allFacilityData?.categoryData//await axios.get(`${endpoints.getCategoryByFacilityId}/${id}`, Auth.loggedIn());
            const facility_category = facility_categoryResponse && facility_categoryResponse.map((value:any) => value.category);
            const abdmDetails = facilityDetails.hfr_id && await axios.get(`${endpoints.getABDMDetails(facilityDetails.hfr_id)}`, Auth.loggedIn());
            const wardUrban = allFacilityData?.linkedWardData;
            const villageRural = allFacilityData?.linkedVillageData;
            const gramPanchayatRural = allFacilityData?.linkedGramPanchayatData;
            facilityDetails.linkedWardRural=wardUrban;
            facilityDetails.linkedVillageRural=villageRural
            facilityDetails.linkedGramPanchayatRural=gramPanchayatRural
              if(facilityDetails.urba_rural_name.toLowerCase() === 'urban') {
                const linkedFacilityRural = allFacilityData?.linkedFacilityData;//await axios.get(`${endpoints.getLinkedFacilitiesByFacilityId}/${id}`, Auth.loggedIn());
                facilityDetails.linkedFacilitiesUrban=linkedFacilityRural
              }
              else{
                const linkedFacilityRural =allFacilityData?.linkedFacilityData;// await axios.get(`${endpoints.getLinkedFacilitiesByFacilityId}/${id}`, Auth.loggedIn());
                facilityDetails.linkedFacilitiesRural=linkedFacilityRural
              }
            setFacility({ ...facilityDetails, facility_category: facility_category, abdmDetails:facilityDetails.hfr_id ? abdmDetails.data.data[0]:"" });
            setShowLoader(false);
          }
        })
        .catch((error: any) => {
          
        });
    }

    useEffect(() => {
      setShowLoader(true);
      getFacility();
      workflowExistsForApproval()
    }, [id]);

    const workflowExistsForApproval = async () => {
    let pendingWorkflow = false;
    let approvalReqId = '';
    let approvalReqStatus = '';
    let reqefectiveData = '';
    try {
      const reqBody = {
        requestForType: 'Facility',
        requestForId: id
      }
      const facility_details_response = await axios.post(endpoints.workflowExistsForApproval, reqBody, Auth.loggedInWithJSON())
      pendingWorkflow = facility_details_response?.data?.data?.check_workflow_exists_for_approval;
      approvalReqId = facility_details_response?.data?.data?.request_serial_id || '';
      approvalReqStatus = facility_details_response?.data?.data?.v_status_name || '';
      reqefectiveData = facility_details_response?.data?.data?.effective_from_date ? dayjs(facility_details_response?.data?.data?.effective_from_date).format(dateFormate.dd_mm_yyyy) : '';
    } catch(error:any) {
      errorLogger(error?.response?.data||error?.response||error)
    }
    setDisableEditBtn(pendingWorkflow);
    setApprovalReqId(approvalReqId);
    setApprovalReqStatus(approvalReqStatus);
    setReqefectiveData(reqefectiveData);
  }
    const facilityType = facility ? facility.facility_status ? facility.facility_status : facility.status: ''
    return (
      <div className="app-view-wrapper health_facility">
        <header className="view-header">
          <div className="logo-wrapper">
            <NationalEmblem className="logo" />
            <div className="name-wrapper">
              <div className="name-wrapper-title">
                JANANI
              </div>
              <div className="name-wrapper-subtext">
                Journey of Antenatal, Natal and Neonatal Integrated Care
              </div>
              <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
            </div>
          </div>
          <div className="view-route">
            <BreadcrumbComponent
              breadcrumbItemName={[
                { value: page, label: 'Health Facility' },
                { value: page, label: 'Health Facility Maintenance' },
              ]}
            />
          </div>
        </header>
        <main className="view-content">
          <div className="view-profile-buttons">
            <div className="view-profile">
              <Link to={'/health-facility'}>
                <Button
                  onClick={() => {
                    clearMapStore();
                  }}
                  disabled={false}
                  id=""
                  buttonName={''}
                  colorType={'verticalbackbutton'}
                  icon={<BackArrowsvg />}
                  iconPosition={'left'}
                />
              </Link>
              {/* <div
                className="profile-picture"
                // style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }} TODO fill PIC from user
              ></div> */}
              <div className="name-type facility">
                {/* <div className="name">{`${user.fName} ${user.mName} ${user.lName}`}</div> */}
                <div className="type ribbon-facility-name">{facility && facility.facility_name}</div>
                {
                facilityType && <div className='status-badge'>
                    <BadgesComponent
                      className="over-badge"
                      badgeName={facilityType}
                      variant={(facilityType === 'Inactive'||facilityType === 'Permanently Closed') ? 'warning' : 'success' }
                      badgeType="case5"
                    />
                </div>
                }
              </div>
              {/* <BadgesComponent
                className="user-status"
                badgeName={user.facility_name}
                variant="success"
                badgeType="case5"
              /> */}
            </div>
            <div className="cancel-edit">
              {props.flow === 'view'?(<>
                <Button
                onClick={() => { navigate(`/health-facility/upgrade/${id}`)}}
                disabled={facilityType === 'Inactive'||facilityType === 'Permanently Closed' || disableEditBtn}
                id="cancel"
                buttonName={'Upgrade /Shift'}
                colorType={'save'}
                icon={''}
                iconPosition={''}
              />
              <Button
                onClick={() => { navigate(`/health-facility/update/${id}`)}}
                disabled={(facilityType === 'Permanently Closed' || disableEditBtn)}
                id="edit-details"
                buttonName={'Correction'}
                colorType={facilityType === 'Permanently Closed'?'disable':'primary'}
                icon={''}
                iconPosition={''}
              />              
              </>):props.flow === 'update'?(<>
                <Link to={'/health-facility'}>
                <Button
                onClick={() => {
                  clearMapStore();
                }}
                disabled={false}
                id="cancel"
                buttonName={'Cancel'}
                colorType={'save'}
                icon={''}
                iconPosition={''}
              />
              </Link>
              <Button
                onClick={updateHandlerUpdate}
                disabled={facilityType === 'Permanently Closed'}
                id="edit-details"
                buttonName={'Save'}
                colorType={facilityType === 'Permanently Closed'?'disable':'primary'}
                icon={''}
                iconPosition={''}
              />              
              </>):props.flow === 'upgrade'?(<>
                <Link to={'/health-facility'}>
                <Button
                onClick={() => {
                  clearMapStore();
                }}
                disabled={false}
                id="cancel"
                buttonName={'cancel'}
                colorType={'save'}
                icon={''}
                iconPosition={''}
              />
              </Link>
              <Button
                onClick={updateHandlerUpgrade}
                disabled={false}
                id="edit-details"
                buttonName={'Upgrade & Next'}
                colorType={'primary'}
                icon={''}
                iconPosition={''}
              />
              
              </>):''}
              
            </div>
          </div>
          <div className='content'>
            <LeftNavBar 
              navItems={TABS}
              currentTab={currentTab}
              handleNavClick={setCurrentTab}
            />
            <div className='tab-content'>
              {!showLoader ? <>
              {disableEditBtn ? <><h6><strong>{setStatusMessage(approvalReqStatus, reqefectiveData, approvalReqId, 'facility')}</strong></h6></> : <></>}
              {currentTab === 'Overview' && <HealthFacilityOverView ref1={childRef1} ref2={childRef2}facility={facility} flow={flow} />}
              </> : <div className='loader'>Loading...</div>}
              {/* {currentTab === 'Privileges' && <>Privileges</>}
              {currentTab === 'Credentials' && <>Credentials</>} */}
            </div>
          </div>
        </main>
      </div>
    );
}
HealthFacilityView.displayName = 'HealthFacilityView';
export default HealthFacilityView;  